import { useNavigate } from 'react-router-dom';
import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import { SellApartmentFlowPaths } from 'routes';
import styles from './styles.module.scss';
import lightning from '../../assets/images/lightning.png';
import background from '../../assets/images/background.png';
import clsx from 'clsx';

const SellFinishScreen: React.FC = () => {
  const navigate = useNavigate();

  const buttons: ButtonProps[] = [
    {
      label: 'Продать с Рейт',
      onClick: () => {
        navigate(SellApartmentFlowPaths.sellReitInformation);
      },
    },
    {
      label: 'Хочу трейд-ин',
      variant: 'gray',
      onClick: () => {
        navigate(SellApartmentFlowPaths.sellTradeInInformation);
      },
    },
  ];

  return (
    <BaseScreen
      padContent
      title='Продать объект'
      buttons={buttons}
      onBackButtonClick={() => navigate(-1)}
    >
      <h2 className={styles.title}>Мы поможем продать вашу квартиру быстрее.</h2>
      <p className={styles.title}>Воспользуйтесь нашими услугами</p>

      <div className={clsx(styles.labelFileUpload)}>
        <div className={styles.uploadContent}>
          <img className={styles.image} src={lightning} />
          <div className={styles.image2}>
            <img src={background} />
          </div>
        </div>
      </div>
    </BaseScreen>
  );
};

export default SellFinishScreen;
